export enum AdyenTransactionResultCode {
  Authorised = 'Authorised',
  Received = 'Received',
  Refused = 'Refused',
}
